import { motion } from "framer-motion";
import { Scissors, Layers, Truck, Wrench, ArrowUpRight } from "lucide-react";

const SERVICES = [
  { icon: Scissors, title: "Corte a medida", text: "Lámina, placa y perfil cortados a la medida exacta de tu proyecto. Cero desperdicio en obra." },
  { icon: Layers, title: "Rolado y conformado", text: "Conformado de lámina en calibres y largos especiales. Fabricamos la pieza que no encuentras en piso." },
  { icon: Wrench, title: "Fabricación especial", text: "Estructuras, marcos y piezas soldadas bajo plano para constructoras y talleres." },
  { icon: Truck, title: "Envíos a todo México", text: "Entregas a obra en Los Mochis y envíos a cualquier estado de la República. Tu material llega completo y a tiempo." },
];

export default function Servicios() {
  return (
    <section id="servicios" className="border-t border-[#1A2235] bg-[#0A0E17]" data-testid="servicios-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-px w-10 bg-[#FF7A00]" />
          <span className="font-mono-ind text-[11px] tracking-[0.25em] uppercase text-[#8B95A5]">Servicios</span>
        </div>
        <h2 className="font-display font-black tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl mb-14 md:mb-20" style={{ fontWeight: 900 }}>
          Más que material,<br /><span className="text-outline">soluciones de fábrica.</span>
        </h2>

        <div>
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group border-b border-[#1A2235] first:border-t py-8 md:py-10 grid grid-cols-12 gap-4 md:gap-8 items-center cursor-default"
              data-testid={`service-${s.title.toLowerCase().replace(/ /g, "-")}`}
            >
              <span className="col-span-2 md:col-span-1 font-mono-ind text-xs text-[#FF7A00]">0{i + 1}</span>
              <div className="col-span-10 md:col-span-3 flex items-center gap-4 transition-transform duration-300 group-hover:translate-x-2">
                <s.icon size={22} className="text-[#8B95A5] group-hover:text-[#FF7A00] transition-colors duration-300" />
                <h3 className="font-display text-xl md:text-3xl font-bold tracking-tight">{s.title}</h3>
              </div>
              <p className="col-span-10 col-start-3 md:col-span-7 md:col-start-5 text-sm md:text-base text-[#8B95A5] leading-relaxed">{s.text}</p>
              <ArrowUpRight size={24} className="hidden md:block col-span-1 justify-self-end text-[#1A2235] group-hover:text-[#FF7A00] group-hover:translate-x-1 group-hover:-translate-y-1 transition-[transform,color] duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
